/**
 * @generated SignedSource<<41eb43818a856a887f0cbc063af4d662>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type IDVFailPageQuery$variables = Record<PropertyKey, never>;
export type IDVFailPageQuery$data = {
  readonly authIdentity: {
    readonly id: string;
    readonly settings: {
      readonly birthday: {
        readonly bornAt: number;
        readonly id: string;
      } | null;
      readonly id: string;
      readonly name: {
        readonly firstName: string | null;
        readonly id: string;
        readonly lastName: string | null;
      } | null;
    } | null;
  };
  readonly identityEditability: {
    readonly dob: {
      readonly editability: boolean;
    };
    readonly firstName: {
      readonly editability: boolean;
    };
    readonly lastName: {
      readonly editability: boolean;
    };
    readonly ssn: {
      readonly editability: boolean;
    };
  };
};
export type IDVFailPageQuery = {
  response: IDVFailPageQuery$data;
  variables: IDVFailPageQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null,
    },
    v1 = [
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'editability',
        storageKey: null,
      },
    ],
    v2 = [
      {
        alias: null,
        args: null,
        concreteType: 'Identity',
        kind: 'LinkedField',
        name: 'authIdentity',
        plural: false,
        selections: [
          v0 /*: any*/,
          {
            alias: null,
            args: null,
            concreteType: 'IdentitySetting',
            kind: 'LinkedField',
            name: 'settings',
            plural: false,
            selections: [
              v0 /*: any*/,
              {
                alias: null,
                args: null,
                concreteType: 'Name',
                kind: 'LinkedField',
                name: 'name',
                plural: false,
                selections: [
                  v0 /*: any*/,
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'firstName',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'lastName',
                    storageKey: null,
                  },
                ],
                storageKey: null,
              },
              {
                alias: null,
                args: null,
                concreteType: 'Birthday',
                kind: 'LinkedField',
                name: 'birthday',
                plural: false,
                selections: [
                  v0 /*: any*/,
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'bornAt',
                    storageKey: null,
                  },
                ],
                storageKey: null,
              },
            ],
            storageKey: null,
          },
        ],
        storageKey: null,
      },
      {
        alias: null,
        args: [
          {
            kind: 'Literal',
            name: 'q',
            value: {
              flowType: 'CREDIT_APPLICATION_IDV_CHALLENGE',
            },
          },
        ],
        concreteType: 'IdentityEditabilityResponse',
        kind: 'LinkedField',
        name: 'identityEditability',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'EditabilityContextType',
            kind: 'LinkedField',
            name: 'firstName',
            plural: false,
            selections: v1 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'EditabilityContextType',
            kind: 'LinkedField',
            name: 'lastName',
            plural: false,
            selections: v1 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'EditabilityContextType',
            kind: 'LinkedField',
            name: 'ssn',
            plural: false,
            selections: v1 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'EditabilityContextType',
            kind: 'LinkedField',
            name: 'dob',
            plural: false,
            selections: v1 /*: any*/,
            storageKey: null,
          },
        ],
        storageKey: 'identityEditability(q:{"flowType":"CREDIT_APPLICATION_IDV_CHALLENGE"})',
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: 'Fragment',
      metadata: null,
      name: 'IDVFailPageQuery',
      selections: v2 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [],
      kind: 'Operation',
      name: 'IDVFailPageQuery',
      selections: v2 /*: any*/,
    },
    params: {
      cacheID: 'b79e6de50b8764415c9d87de24276165',
      id: null,
      metadata: {},
      name: 'IDVFailPageQuery',
      operationKind: 'query',
      text: 'query IDVFailPageQuery {\n  authIdentity {\n    id\n    settings {\n      id\n      name {\n        id\n        firstName\n        lastName\n      }\n      birthday {\n        id\n        bornAt\n      }\n    }\n  }\n  identityEditability(q: {flowType: CREDIT_APPLICATION_IDV_CHALLENGE}) {\n    firstName {\n      editability\n    }\n    lastName {\n      editability\n    }\n    ssn {\n      editability\n    }\n    dob {\n      editability\n    }\n  }\n}\n',
    },
  };
})();

(node as any).hash = '5b000aaa169f2f9624c21ec05b83d1a9';

export default node;
